import PropTypes from 'prop-types'
import { createContext, useReducer } from 'react'
import store from 'store'

import useAuth from 'hooks/use-auth'

const UpgradePanelContext = createContext()

const getLocalStorageUpgradeRequestStatus = (companyId) => {
  // Storing the value in localStorage to prevent the banner from showing
  // when the user has already requested an upgrade.
  // The contract upgrade request will not be set on the session until the
  // next time the user has logged in again or their token is renewed.
  const contractUpgradeRequests = store.get('contractUpgradeRequests')

  if (contractUpgradeRequests) {
    return contractUpgradeRequests[companyId]
  } else {
    store.set('contractUpgradeRequests', {})

    return false
  }
}

const initialState = (hasUpgradeBeenRequested, companyId) => ({
  upgradePanelOpen: false,
  hasUpgradeBeenRequested:
    hasUpgradeBeenRequested || getLocalStorageUpgradeRequestStatus(companyId)
})

const reducer = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case 'toggleUpgradePanel':
      return {
        ...state,
        upgradePanelOpen: !state.upgradePanelOpen
      }
    case 'setUpgradeHasBeenRequested':
      return {
        ...state,
        hasUpgradeBeenRequested: true
      }
    default:
      return state
  }
}

const UpgradePanelProvider = ({ children }) => {
  const { hasUpgradeBeenRequested, companyId } = useAuth()

  const [state, dispatch] = useReducer(
    reducer,
    initialState(hasUpgradeBeenRequested, companyId)
  )
  const value = { state, dispatch }

  return (
    <UpgradePanelContext.Provider value={value}>
      {children}
    </UpgradePanelContext.Provider>
  )
}

UpgradePanelProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export { UpgradePanelContext, UpgradePanelProvider }
